import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Static CSS"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "static-css"
    }}>{`Static CSS`}</h1>
    <p>{`Certain projects have constraints that require using static CSS rather
than CSS-in-JS. Theme UI contains (experimental) libraries to transform
a theme config to the proper format for other CSS libraries.`}</p>
    <p>{`This allows you to use the Theme UI implementation in React-based projects
and share the same theme or design tokens in your design system with other projects so you
can incrementally adopt Theme UI.`}</p>
    <h2 {...{
      "id": "get-started"
    }}>{`Get started`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/css/tailwind"
        }}>{`Tailwind`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/css/tachyons"
        }}>{`Tachyons`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/system-ui/theme-ui/issues/103"
        }}>{`TODO: Bootstrap`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/system-ui/theme-ui/issues/104"
        }}>{`TODO: Bulma`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      